import { render, staticRenderFns } from "./VlDatePickerLarge.vue?vue&type=template&id=2ef04811&"
import script from "./VlDatePickerLarge.vue?vue&type=script&lang=js&"
export * from "./VlDatePickerLarge.vue?vue&type=script&lang=js&"
import style0 from "./VlDatePickerLarge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports